/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsstickinesshint2Inputs */

const en_statsstickinesshint2 = /** @type {(inputs: Statsstickinesshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active in 24 h divided by active in 30 days: how many monthly actives show up every day.`)
};

const de_statsstickinesshint2 = /** @type {(inputs: Statsstickinesshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv in 24 Std. geteilt durch aktiv in 30 Tagen: wie viele der Monatsaktiven jeden Tag da sind.`)
};

/**
* | output |
* | --- |
* | "Active in 24 h divided by active in 30 days: how many monthly actives show up every day." |
*
* @param {Statsstickinesshint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsstickinesshint2 = /** @type {((inputs?: Statsstickinesshint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsstickinesshint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsstickinesshint2(inputs)
	return de_statsstickinesshint2(inputs)
});
export { statsstickinesshint2 as "statsStickinessHint" }